import {Component, OnInit} from '@angular/core';
import {ActivePageHelperService} from './services/helpers/active-page-helper.service';
import {EchoHelperService} from './services/helpers/echo-helper.service';
import {AuthenticationHelperService} from './services/helpers/authentication-helper.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  constructor(private echoHelperService: EchoHelperService,
              public activePageHelper: ActivePageHelperService,
              public authHelperService: AuthenticationHelperService) {
  }

  ngOnInit(): void {
    this.initializeApp();
  }

  initializeApp(): void {
    this.authHelperService.authStatus$.subscribe((userData: boolean) => {
      if (userData) {
        this.echoHelperService.initEcho();
        // if (this.authHelperService.getAuthUserRole === UserRoles.user) {
        //   this.getAdministrationsAndDeliveryCost();
        // }
      }
    });
  }
}
